import Editor from "@monaco-editor/react";
import { useEffect } from "react";
import "./CodeEditor.css";

export default function CodeEditor({ language, code, setCode }) {
  const email = localStorage.getItem("email");
  const isSubAdmin = email === "subadmin@tss.in";

  const handleEditorDidMount = (editor, monaco) => {
    /* ---------- SUBADMIN: NO SECURITY RESTRICTIONS ---------- */
    if (isSubAdmin) {
      return;
    }

    /* ---------- DESKTOP SECURITY ---------- */
    editor.updateOptions({
      contextmenu: false,
      dragAndDrop: false,
      quickSuggestions: false,
    });

    const blockCommand = (keybinding) => {
      editor.addCommand(keybinding, () => {});
    };

    // Block common shortcuts
    blockCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyC);
    blockCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyV);
    blockCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyX);
    blockCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyA);
    blockCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyS);
    blockCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyZ);

    /* ---------- EDITOR DOM LEVEL BLOCK ---------- */
    const domNode = editor.getDomNode();
    if (!domNode) return;

    const blockEvent = (e) => {
      e.preventDefault();
      e.stopPropagation();
      return false;
    };

    ["copy", "paste", "cut", "contextmenu"].forEach((event) => {
      domNode.addEventListener(event, blockEvent);
    });
  };

  /* ---------- GLOBAL COPY / PASTE BLOCK ---------- */
  useEffect(() => {
    // Don't block anything for subadmin
    if (isSubAdmin) {
      return;
    }

    const block = (e) => {
      e.preventDefault();
      return false;
    };

    document.addEventListener("copy", block);
    document.addEventListener("paste", block);
    document.addEventListener("cut", block);

    return () => {
      document.removeEventListener("copy", block);
      document.removeEventListener("paste", block);
      document.removeEventListener("cut", block);
    };
  }, [isSubAdmin]);

  return (
    <Editor
      height="620px"
      language={language}
      value={code}
      theme="vs-dark"
      onChange={(value) => setCode(value || "")}
      onMount={handleEditorDidMount}
      options={{
        fontSize: 14,
        minimap: { enabled: false },
        automaticLayout: true,
        scrollBeyondLastLine: false,
        selectionClipboard: false,
        wordWrap: "on",
        smoothScrolling: true,
        cursorSmoothCaretAnimation: "on",
      }}
    />
  );
}